module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    on: {
      "click": _vm.$_onItemClick
    }
  }, [(!_vm.isLast) ? _c('div', {
    class: (_vm.prefixStepsClass + "-tail")
  }, [_c('i')]) : _vm._e(), _vm._v(" "), _c('div', {
    class: (_vm.prefixStepsClass + "-step")
  }, [_c('div', {
    class: (_vm.prefixStepsClass + "-head")
  }, [_c('div', {
    class: (_vm.prefixStepsClass + "-head__inner")
  }, [(_vm.icon || _vm.status === 'finish' || _vm.status === 'error') ? _c('span', {
    class: _vm.iconClass
  }) : _c('span', {
    class: (_vm.prefixStepsClass + "-icon")
  }, [_vm._v("\n          " + _vm._s(_vm.stepNumber) + "\n        ")])])]), _vm._v(" "), _c('div', {
    class: (_vm.prefixStepsClass + "-main")
  }, [_c('div', {
    class: (_vm.prefixStepsClass + "-main__title")
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.desc) ? _c('div', {
    class: (_vm.prefixStepsClass + "-main__description")
  }, [_vm._v(_vm._s(_vm.desc))]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-894851ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/step.vue
// module id = 393
// module chunks = 0